export default __webpack_public_path__ + "static/side-menu-btn-ios-68322710893884431dbdc96ae360a8a5.png";